import { ColorValue, StyleProp, StyleSheet, View, ViewStyle } from "react-native";
import { useTheme } from "../hooks/use-theme";

type FullWidthLineProps = {
    color?: ColorValue;
    style?: StyleProp<ViewStyle>;
};

const FullWidthLine = ({ color, style }: FullWidthLineProps) => {
    const styles = useStyles();

    return <View style={[styles.line, style, color && { backgroundColor: color }]} />;
};

const useStyles = () => {
    const { marginSize, colors } = useTheme();

    return StyleSheet.create({
        line: {
            marginHorizontal: -marginSize,
            height: 2,
            backgroundColor: colors.lighterGrey,
        },
    });
};

export default FullWidthLine;
